import React from 'react';
import {NavMenu} from './NavMenu';
import Header from "./Header";

export let Layout = ({children}) => (
    <>
      <Header/>
    <div style={{display:'flex'}}>
        <NavMenu/>
        <div className='admin-container'>
            {children}
        </div>
    </div>
    </>
);

Layout.displayName = Layout.name;
